// 新客优惠专区路由
export default {
  routes: [
    // 首页
    {
      path: '/newUserShopZone/index',
      name: 'newUserShopZoneIndex',
      meta: {
        desc: '新人专区'
      },
      component: () =>
        import(/* webpackChunkName: "newUserShopZoneIndex" */ '../views/newUserShopZone/index.vue')
    },
    {
      path: '/newUserShopZone/c2cIndex',
      name: 'newUserShopZoneC2CIndex',
      meta: {
        desc: 'C2C新人专区'
      },
      component: () =>
        import(
          /* webpackChunkName: "newUserShopZoneC2CIndex" */ '../views/newUserShopZone/c2cIndex.vue'
        )
    },
    // 一元购
    {
      path: '/newUserShopZone/onebuck',
      name: 'newUserShopZoneOneBuck',
      meta: {
        desc: '新人一元购'
      },
      component: () =>
        import(
          /* webpackChunkName: "newUserShopZoneOneBuck" */ '../views/newUserShopZone/OneBuck.vue'
        )
    }
  ]
}
